import initial from "../secrets-web/src/store/initial";

export default {
  ...initial,
  auth: {
    ...initial.auth,
    userPm: null
  }
}